import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=6cea18e8&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=ts&"
export * from "./Info.vue?vue&type=script&lang=ts&"
import style0 from "./Info.vue?vue&type=style&index=0&id=6cea18e8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cea18e8",
  null
  
)

export default component.exports